import { useDispatch } from "react-redux";
import { Checkbox } from "@rmwc/checkbox";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import CurrencyFormat from "react-currency-format";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";
import Popover from "react-bootstrap/Popover";
import { extraItemsAction } from "../../../action";
import { const_var, params } from "../../../redux/reducers/reducer";

const AdditionalFeatures = ({ elementPrice }) => {
	const dispatch = useDispatch();

	if (!(const_var.a_p_d_a.additional_features && const_var.a_p_d_a.additional_features.length > 0)) {
		return;
	}

	let isIncluded = false;

	const cb_a_p_d_a = structuredClone(const_var.holdPricingResponse ?? "");

	return (
		<>
			{const_var.a_p_d_a?.additional_features?.map((val, index) => {
				if (!val) {
					return;
				}

				let valPro = const_var.additionalFeaturesArray?.find((item) => item?.id === val.id || item?.additional_feature == val?.additional_feature);
				if (const_var.isLTBuilding) {
					const x = const_var.selectedLeanType === "" ? "centerBuilding" : const_var.selectedLeanType;
					valPro = const_var.lNTBuildingData.additionalFeaturesArray[x]?.find((item) => item && item.additional_feature.trim() === val.additional_feature.trim());
				}
				const show = val.is_outside_extra_item != undefined && val.is_outside_extra_item == 1 && val.additional_feature.includes("26 GA Panel");
				return (
					<div className={show == true ? "control-field-bar d-none" : "control-field-bar"}>
						<div className="control-field">
							<div className="check-group">
								<Checkbox
									checked={!!valPro?.is_checked}
									label={
										val.additional_feature +
										`${const_var.additionalFeaturesArray.length > 0 && const_var.additionalFeaturesArray[index] != undefined && const_var.additionalFeaturesArray[index].is_disabled != undefined ? " (Included)" : ""}`
									}
									disabled={
										const_var.additionalFeaturesArray.length > 0 && const_var.additionalFeaturesArray[index] != undefined && const_var.additionalFeaturesArray[index].is_disabled != undefined
											? const_var.additionalFeaturesArray[index].is_disabled
											: false
									}
									onChange={() => dispatch(extraItemsAction("on", "additionalFeatures", val, index))}
								/>
								<OverlayTrigger
									trigger="hover"
									placement={window.innerWidth > 992 ? "left-start" : "bottom"}
									rootClose={true}
									overlay={
										<Popover className="popover-info popover-md">
											<Popover.Content>
												<div className="info-content">
													<p>This item is not shown on the configurator, but gets added to your building design and may increase the price</p>
												</div>
											</Popover.Content>
										</Popover>
									}
								>
									<span className="control-info-tip">
										<i class="icon-eye-off"></i>
									</span>
								</OverlayTrigger>
							</div>
						</div>
						{const_var?.additionalFeaturesArray?.[index]?.is_checked && isIncluded == false && (
							<div className={`control-field-action ${const_var.additionalFeaturesArray?.[index]?.is_disabled ? "disabled" : ""}`}>
								{const_var.loginSession == true ? (
									<div className="price-box">
										<EditPriceItem
											is_disabled={valPro?.is_checked}
											jsonObj={"extraitems"}
											jsonObjValue={valPro?.is_checked}
											jsonObjKey={val.additional_feature}
											elementObjIndex={index}
											extraItemType={"additionalFeatures"}
											priceKey={"additionalFeaturesArray"}
										/>
									</div>
								) : (
									<div className="price-box-type-2">
										{const_var.hide_price_calculation != 1 && elementPrice?.[val.additional_feature]?.item_price !== undefined && (
											<CurrencyFormat value={elementPrice[val.additional_feature]?.item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
										)}
									</div>
								)}
							</div>
						)}
					</div>
				);
			})}
		</>
	);
};

export default AdditionalFeatures;
